// Utility function to check if string is a valid URL
const isUrl = (x: string): boolean => {
  try {
    return Boolean(new URL(x));
  } catch (e) {
    return false;
  }
};


export { isUrl };
